export default __webpack_public_path__ + "static/media/phone-icon.7bc0fc90.svg";